import { type MutableRefObject, useEffect, useRef } from 'react';

type UseEventSourceOptions = {
  shouldListen?: boolean;
  // onOpen: (value: Event) => void;
  // onMessage: (message: MessageEvent) => void;
  // onError: (error: Event) => void;
};

const useEventSource = (url: string, options?: UseEventSourceOptions) => {
  const { shouldListen } = options || {};
  const eventSourceRef: MutableRefObject<EventSource | null> = useRef(null);

  useEffect(() => {
    const createEventSource = () => {
      eventSourceRef.current = new EventSource(url, {});
    };

    const teardownEventSource = () => {
      eventSourceRef.current?.close();
    };

    if (shouldListen) {
      createEventSource();
    } else {
      teardownEventSource();
    }

    return () => {
      teardownEventSource();
    };
  }, [shouldListen, url]);

  return eventSourceRef.current;
};

export default useEventSource;
